import React from 'react';
import { motion } from 'framer-motion';
import { skillGroups } from '../../data/portfolioData';

export default function SkillsCloud() {
  return (
    <section id="skills" className="mx-auto w-full max-w-7xl px-4 py-20 sm:px-6 lg:px-10">
      <div className="mb-10">
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-cyan-300">Technical Proficiency</p>
        <h2 className="font-display text-3xl font-bold text-white sm:text-5xl">Skills Cloud</h2>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        {skillGroups.map((group, groupIndex) => (
          <motion.article
            key={group.title}
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.45, delay: groupIndex * 0.1 }}
            className="glass-card"
          >
            <h3 className="font-display text-xl font-bold text-white">{group.title}</h3>
            <div className="mt-4 flex flex-wrap gap-3">
              {group.items.map((item, itemIndex) => {
                const Icon = item.icon;
                return (
                  <motion.span
                    key={item.name}
                    initial={{ opacity: 0, scale: 0.88 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ delay: itemIndex * 0.05 }}
                    whileHover={{ y: -4 }}
                    className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-3 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-slate-100"
                  >
                    <Icon className="text-base text-cyan-300" />
                    {item.name}
                  </motion.span>
                );
              })}
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
